export default {

  create(_, data, BACKEND) {
    return {
      committedTimeDaily: data.committedTimeDaily // time in seconds
    }
  },

  fields: {
    committedTimeDaily: { validate_bolt_type: 'Number' },
  }
};
